import React from 'react';

const SectionDivider = () => {
  return (
    <div className="section-divider between"></div>
  );
};

export default SectionDivider;







